const eventsBotWizardNames = {
	// bot wizard
	generateBotOpened: 'generate_bot_opened',
	generateBotDescriptionStep: 'generate_bot_description_step',
	generateBotRebuild: 'generate_bot_rebuild',
	generateBotActivate: 'generate_bot_activate',
	generateBotActivateUsingNeurons: 'generate_bot_activate_using_neurons',
	generateBotError: 'generate_bot_error',
	generateBotSummary: 'generate_bot_summary',
	generateBotGenerationStep: 'generate_bot_generation_step',
};

export default eventsBotWizardNames;
